/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */
/* eslint-disable react/prop-types, max-len */
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './AddComposition.scss';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

import ModalAlert from '../../../ModalAlert';
import { addComposition } from '../../../../../actions/district';
import { setCurrentMapComposition } from '../../../../../actions/layers';

const fastStyleMargin = {
  marginTop: '7px',
};

const ModalGroupName = (props) => {
  return (
    <Modal show={props.show} onHide={props.onHide}>
      <Modal.Header className="bg-warning" closeButton>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.bodyText}
        <br /><br />
        <Button className="btn btn-info pull-right" onClick={props.onHide}>Anuluj</Button>
        <Button className="btn btn-warning pull-right" onClick={props.onOk}>OK</Button>
        <br /><br />
      </Modal.Body>
    </Modal>
  );
};

class AddComposition extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      composition_types: [''].concat(_.sortBy(_.uniq(_.map(this.props.district.compositions, 'composition_type')))),
      data: {
        composition_type: null,
        groups: [],
        isDefault: false,
        is_public: false,
        layers: [],
        nazwa: '',
        typ: 'Mapa',
      },
      extLayers: this.props.district.externalLayers,
      layers: this.props.district.layers,
      leftLayers: false,
      modalTitle: '',
      modalBody: '',
      newCompositionTypeName: '',
      newGroupName: '',
      rightLayers: false,
      showModal: false,
      showModalCompositionTypeName: false,
      showModalGroupName: false,
    };
    this.baseState = this.state
  }

  resetComponent = () => {
    this.props.cancelEditComposition();
  }

  componentDidMount = () => {
    if (this.props.composition) {
      this.setState({
        data: {
          ...this.props.composition
        }
      })
    }
  }

  onHide = () => this.setState({ 
    showModalCompositionTypeName: false, 
    newCompositionTypeName: '', 
    showModalGroupName: false, 
    newGroupName: '' 
  });
  dismissModal = () => this.setState({ showModal: false });
  
  onOk = () => {
    this.state.newCompositionTypeName != '' &&
    this.setState({
      ...this.state,
      data: {
        ...this.state.data,
        composition_type: this.state.newCompositionTypeName
      },
      composition_types: this.state.composition_types.concat(this.state.newCompositionTypeName)
    }, () => this.onHide())

    this.state.newGroupName != '' &&
    this.setState({
      ...this.state,
      data: {
        ...this.state.data,
        groups: this.state.data.groups.concat({
          nazwa: this.state.newGroupName,
          nr: this.selectR.children.length + 1,
        }),
      },
    }, () => this.onHide())
  }

  onChangeNewCompositionTypeName = (e) => this.setState({ newCompositionTypeName: e.target.value });
  onChangeNewGroupName = (e) => this.setState({ newGroupName: e.target.value });

  onChangeLeftLayers = (e) => {
    this.setState({ leftLayers: e.target.value, rightLayers: '' });
  }

  onChangeRightLayers = (e) => {
    this.setState({ rightLayers: e.target.value, leftLayers: '' });
  }

  addLayer = (e) => {

    if (!this.state.leftLayers.isExternal) {
      this.setState({
        ...this.state,
        layers: _.filter(this.state.layers, (v) => v.name !== this.state.leftLayers.layer[this.state.leftLayers.isExternal ? 'nazwa' : 'name']),
        data: {
          ...this.state.data,
          layers: this.state.data.layers.concat({
            warstwa: this.state.leftLayers.layer[this.state.leftLayers.isExternal ? 'nazwa' : 'name'],
            grupa: '',
            nr: this.state.data.layers.length + this.state.data.groups.length + 1,
            isExternal: this.state.leftLayers.isExternal,
          }),
        },
      }, () => {
        this.deselectLeft();
      });
    } else {
      this.setState({
        ...this.state,
        extLayers: _.filter(this.state.extLayers, (v) => v.nazwa !== this.state.leftLayers.layer.nazwa),
        data: {
          ...this.state.data,
          layers: this.state.data.layers.concat({
            warstwa: this.state.leftLayers.layer.nazwa,
            grupa: '',
            nr: this.state.data.layers.length + this.state.data.groups.length + 1,
            isExternal: this.state.leftLayers.isExternal,
          }),
        },
      }, () => {
        this.deselectLeft();
      });
    }
  }

  removeLayer = (e) => {
    this.setState({
      ...this.state,
      layers: this.state.layers.concat(_.filter(this.props.district.layers, v => v.name === this.state.rightLayers.obj.warstwa)),
      data: {
        ...this.state.data,
        layers:  _.filter(this.state.data.layers, (v) => v.warstwa !== this.state.rightLayers.obj.warstwa),
      },
    }, () => {
      this.deselectRight();
    });
  }

  deselectLeft = () => {
    for (const index in this.selectL.children) {
      if (this.selectL.children[index].selected !== undefined) {
        this.selectL.children[index].selected = false;
      }
    }
    this.setState({ leftLayers: null });
  }

  deselectRight = () => {
    for (const index in this.selectR.children) {
      if (this.selectR.children[index].selected !== undefined) {
        this.selectR.children[index].selected = false;
      }
    }
    this.setState({ rightLayers: null });
  }

  optionSelect = (v, isExternal) => {
    this.setState({ leftLayers: { layer: v, isExternal }, rightLayers: false }, this.deselectRight());
  }

  onRightOptionSelect = (v, isGroup) => {
    this.setState({ rightLayers: { obj: {...v}, isGroup }, leftLayers: false }, () => {
      this.deselectLeft();
    });
  }

  renderComposition = () => {

  }

  onAddCompositionType = () => {
    this.setState({ showModalCompositionTypeName: true });
  }

  onAddGroup = () => {
    this.setState({ showModalGroupName: true });
  }

  onChangeCompositionType = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        composition_type: e.target.value
      }
    });
  }

  deleteCompositionType = () => {
    this.setState({
      ...this.state,
      composition_types: _.filter(this.state.composition_types, v => v !== this.state.data.composition_type),
      data: {
        ...this.state.data,
        composition_type: null
      },
    });
  }

  deleteGroup = () => {
    const isGroup = this.state.rightLayers.isGroup;

    // Sprawdzamy czy zaznaczony element jest grupa
    if(isGroup) {

      // Usuwamy element i od razu zapisujemy
      this.setState({
        data: {
          ...this.state.data,
          groups: _.filter(this.state.data.groups, v => v.nazwa !== this.state.rightLayers.obj.nazwa)
        },
      });
    }
  }

  moveUp = () => {
    const isGroup = this.state.rightLayers.isGroup;
    const i = this.state.rightLayers.obj.nr;
    const prevOption = _.find(this.state.data.layers.concat(this.state.data.groups), (o) => o.nr + 1 === i);
    const grupa = ('grupa' in prevOption) ? prevOption.grupa : prevOption.nazwa;
    const isPrevGroup = !('grupa' in prevOption);
    if (isPrevGroup && !isGroup) {
      this.addLayerToGroup(grupa, i - 1);
    }
    if (isPrevGroup && this.state.rightLayers.obj.grupa === prevOption.nazwa && !isGroup) {
      this.removeLayerFromGroup(i - 1);
      this.moveLayer(i, true);
    }
    if (!isPrevGroup && !isGroup) {
      if (grupa) {
        if (grupa === this.state.rightLayers.obj.grupa) {
          this.moveLayer(i, true);
        } else {
          this.addLayerToGroup(grupa);
        }
      } else {
        this.moveLayer(i, true);
      }
    }
    if (isGroup) {
      if ('grupa' in prevOption) {
        if (prevOption.grupa === '') { // przed grupą jest warstwa bez grupy
          this.moveGroupByStep(this.state.rightLayers.obj.nazwa, true, 1);
        } else { // przed grupą jest warstwa zawarta w grupie
          this.moveGroupByStep(this.state.rightLayers.obj.nazwa, true, this.getGroupSize(prevOption.grupa));
        }
      } else { // dwie grupy obok siebie
        this.moveGroupByStep(this.state.rightLayers.obj.nazwa, true, 1);
      }
    }
  }

  moveGroupByStep = (groupName, up, step) => {
    const groupSize = this.getGroupSize(groupName);
    let groupStart = 0;
    _.find(this.state.data.groups, (o) => {
      if (o.nazwa === groupName) {
        groupStart = o.nr;
      }
    });
    const groups = _.filter(this.state.data.groups, (o) => {
      if (up) {
        if (o.nr >= groupStart - step && o.nr < groupStart) {
          o.nr = o.nr + groupSize;
          return o;
        }
        if (o.nr >= groupStart && o.nr < groupStart + groupSize) {
          o.nr = o.nr - step;
          return o;
        }
      } else {
        if (o.nr >= groupStart && o.nr < groupStart + groupSize) {
          o.nr = o.nr + step;
          return o;
        }
        if (o.nr >= groupStart + groupSize && o.nr < groupStart + groupSize + step) {
          o.nr = o.nr - groupSize;
          return o;
        }
      }
      return o;
    });
    const layers = _.filter(this.state.data.layers, (o) => {
      if (up) {
        if (o.nr >= groupStart - step && o.nr < groupStart) {
          o.nr = o.nr + groupSize;
          return o;
        }
        if (o.nr >= groupStart && o.nr < groupStart + groupSize) {
          o.nr = o.nr - step;
          return o;
        }
      } else {
        if (o.nr >= groupStart && o.nr < groupStart + groupSize) {
          o.nr = o.nr + step;
          return o;
        }
        if (o.nr >= groupStart + groupSize && o.nr < groupStart + groupSize + step) {
          o.nr = o.nr - groupSize;
          return o;
        }
      }
      return o;
    });

    this.setState({
      data: {
        ...this.state.data,
        groups,
        layers,
      },
    }, () => this.selectRightOptionByIndex((up) ? (groupStart - step) - 1 : (groupStart + step) - 1));
  }

  moveGroup = (groupName, up, step) => {
    let i = null;
    let groupSize = 1;
    for (const k in this.state.data.layers) {
      if (this.state.data.layers[k].grupa === groupName) {
        groupSize = groupSize + 1;
      }
    }
    const groups =  _.filter(this.state.data.groups, (o) => {
      const testOld = up ? o.nr - step : o.nr + step;
      if (o.nazwa === groupName) {
        o.nr = up ? o.nr - step : o.nr + step;
        i = o.nr;
        return o;
      }
      if (o.nr + 1 === testOld) {
        o.nr = up ? o.nr + step : o.nr - step;
        return o;
      }
      return o;
    });
    const layers =  _.filter(this.state.data.layers, (o) => {
      if (o.nr === i) {
        o.nr = up ? o.nr + groupSize : o.nr - groupSize;
        return o;
      }
      if (o.grupa === groupName) {
        o.nr = up ? o.nr - step : o.nr + step;
        return o;
      }
      return o;
    });
    this.setState({
      data: {
        ...this.state.data,
        groups,
        layers,
      },
    }, () => this.selectRightOptionByIndex(i - 1));
  }

  moveGroupDown = (groupName, up) => {
    let i = null;
    let groupSize = 1;
    for (const k in this.state.data.layers) {
      if (this.state.data.layers[k].grupa === groupName) {
        groupSize = groupSize + 1;
      }
    }
    this.setState({
      data: {
        ...this.state.data,
        groups: _.filter(this.state.data.groups, (o) => {
          if (o.nazwa === groupName) {
            o.nr = o.nr + 1;
            i = o.nr;
            return o;
          }
          return o;
        }),
        layers: _.filter(this.state.data.layers, (o) => {
          if (o.nr === i + groupSize - 1) {
            o.nr = o.nr - groupSize;
            return o;
          }
          if (o.grupa === groupName) {
            o.nr = o.nr + 1;
            return o;
          }
          return o;
        }),
      },
    }, () => this.selectRightOptionByIndex(i - 1));
  }

  moveLayer = (i, up) => this.setState({
    data: {
      ...this.state.data,
      groups: _.filter(this.state.data.groups, (o) => {
        if (up) {
          if (o.nr === i) {
            o.nr = o.nr - 1;
            return o;
          }
          if (o.nr === i - 1) {
            o.nr = i;
            return o;
          }
        } else {
          if (o.nr === i) {
            o.nr = o.nr + 1;
            return o;
          }
          if (o.nr === i + 1) {
            o.nr = i;
            return o;
          }
        }
        return o;
      }),
      layers: _.filter(this.state.data.layers, (o) => {
        if (up) {
          if (o.nr === i) {
            o.nr = o.nr - 1;
            return o;
          }
          if (o.nr === i - 1) {
            o.nr = i;
            return o;
          }
        } else {
          if (o.nr === i) {
            o.nr = o.nr + 1;
            return o;
          }
          if (o.nr === i + 1) {
            o.nr = i;
            return o;
          }
        }
        return o;
      }),
    },
  }, () => this.selectRightOptionByIndex(up ? i - 2 : i));

  addLayerToGroup = (groupName, i) => this.setState({
    data: {
      ...this.state.data,
      layers: _.filter(this.state.data.layers, (o) => {
        if (o.nr === this.state.rightLayers.obj.nr) {
          o.grupa = groupName;
          return o;
        }
        return o;
      }),
    },
  }, () => this.selectRightOptionByIndex(i));

  removeLayerFromGroup = (i) => this.setState({
    data: {
      ...this.state.data,
      layers: _.filter(this.state.data.layers, (o) => {
        if (o.nr === this.state.rightLayers.obj.nr) {
          o.grupa = '';
          return o;
        }
        return o;
      }),
    },
  }, () => this.selectRightOptionByIndex(i));

  moveDown = () => {
    const isGroup = this.state.rightLayers.isGroup;
    const i = this.state.rightLayers.obj.nr;
    let nextOption = null;
    let allItems = this.state.data.layers.concat(this.state.data.groups).sort((a, b) => a.nr - b.nr);
    for (const k in allItems) {
      if (k >= i) {
        if ('grupa' in allItems[k]) {
          if (allItems[k].grupa === ''){
            nextOption = allItems[k];
            break;
          }
        } else {
          nextOption = allItems[k];
          break;
        }
      }
    }
    const grupa = ('grupa' in nextOption) ? nextOption.grupa : nextOption.nazwa;
    const isNextGroup = !('grupa' in nextOption);
    if (isNextGroup && !isGroup) {
      this.addLayerToGroup(grupa, i - 1);
      this.moveLayer(i, false);
    }
    if (!isNextGroup && !isGroup) {
      this.addLayerToGroup(grupa);
      this.moveLayer(i, false);
    }
    if (isGroup) {
      if ('grupa' in nextOption) {
        this.moveGroupByStep(this.state.rightLayers.obj.nazwa, false, 1);
      } else { // dwie grupy obok siebie
        this.moveGroupByStep(this.state.rightLayers.obj.nazwa, false, this.getGroupSize(nextOption.nazwa));
      }
    }
  }

  getGroupSize = (groupName) => {
    let groupSize = 1;
    for (const k in this.state.data.layers) {
      if (this.state.data.layers[k].grupa === groupName) {
        groupSize = groupSize + 1;
      }
    }
    return groupSize;
  }

  selectRightOptionByIndex = (i) => {
    this.deselectRight();
    if (this.selectR.children[i]) this.selectR.children[i].selected = true;
    const isLayer = _.find(this.state.data.layers, (o) => o.nr - 1 === i);
    const isGroup = _.find(this.state.data.groups, (o) => o.nr - 1 === i);
    if (isLayer) {
      this.onRightOptionSelect(isLayer, false);
    }
    if (isGroup) {
      this.onRightOptionSelect(isGroup, true);
    }

  }

  isDefaultChange = () => {
    this.setState({
      data: {
        ...this.state.data,
        isDefault: !this.state.data.isDefault,
      },
    });
  }

  isPublicChange = () => {
    this.setState({
      data: {
        ...this.state.data,
        is_public: !this.state.data.is_public,
      },
    });
  }

  onChangeType = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        typ: e.target.value,
      },
    });
  }

  onChangeName = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        nazwa: e.target.value,
      },
    });
  }

  zapiszKompozycje = () => {
    this.props.addComposition(this.props.district.prefix, this.state.data)
    .then((resp) => {
      this.setState({
        modalTitle: 'Status',
        modalBody: 'Pomyślnie dodano kompozycję mapową.',
        showModal: true,
        data: {
          isDefault: false,
          is_public: false,
          typ: 'Mapa',
          nazwa: '',
          composition_type: null,
          groups: [],
          layers: [],
        },
      });
    })
    .catch((error) => {
      console.info(error);
    });
    this.props.setCurrentMapComposition(this.state.data);
    this.resetComponent();
  }

  render() {
    return (
      <div className="col-xs-12">
        <div className="row">
          <div className="form-inline">
            <label htmlFor="compositionName" className="col-xs-3" style={fastStyleMargin}>Nazwa</label>
            <input name="compositionName" value={this.state.data.nazwa} onChange={(e) => this.onChangeName(e)} className="form-control" type="text" />
          </div>
        </div>
        <div className="row">
          <div className="form-inline">
            <label htmlFor="compositionTyp" className="col-xs-3" style={fastStyleMargin}>Typ</label>
            <select value={this.state.data.typ} onChange={(e) => this.onChangeType(e)} className="form-control" name="compositionTyp">
              <option>Mapa</option>
              <option>Minimapa</option>
            </select>
          </div>
        </div>
        <div className="row">
          <div className="form-inline">
            <label htmlFor="compositionTyp" className="col-xs-3" style={fastStyleMargin}>Kategoria kompozycji</label>
            <select value={this.state.data.composition_type?this.state.data.composition_type:''} onChange={(e) => this.onChangeCompositionType(e)} className="form-control" name="compositionTyp">
              {this.state.composition_types.map((v, i) => <option key={i} value={v}>{v}</option>)}
            </select>&nbsp;&nbsp;
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Dodaj kategorię</Tooltip>}>
              <button className="btn btn-warning" onClick={() => this.onAddCompositionType()}>+</button>
            </OverlayTrigger>&nbsp;&nbsp;
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Usuń kategorię</Tooltip>}>
              <button className="btn btn-warning" disabled={!this.state.data.composition_type} onClick={() => this.deleteCompositionType()}>-</button>
            </OverlayTrigger>
          </div>
        </div>
        <div className="row" style={fastStyleMargin}>
          <div className="form-inline">
            <label htmlFor="compositionTyp" className="col-xs-3" style={fastStyleMargin}>Domyślny</label>
            <input
              name="isDefault"
              type="checkbox"
              checked={this.state.data.isDefault}
              onChange={this.isDefaultChange}
            />
          </div>
        </div>
        <div className="row" style={fastStyleMargin}>
          <div className="form-inline">
            <label htmlFor="compositionTyp" className="col-xs-3" style={fastStyleMargin}>Publiczny</label>
            <input
              name="isDefault"
              type="checkbox"
              checked={this.state.data.is_public}
              onChange={this.isPublicChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-5">
            <label htmlFor="sel2">Wybierz warstwy kompozycji.</label>
          </div>
          <div className="col-xs-2" />
          <div className="col-xs-5">
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Dodaj grupę</Tooltip>}>
              <button className="btn btn-warning" onClick={() => this.onAddGroup()}>+</button>
            </OverlayTrigger>&nbsp;&nbsp;

            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Usuń grupę</Tooltip>}>
              <button className="btn btn-warning" disabled={!this.state.rightLayers || !this.state.rightLayers.isGroup} onClick={() => this.deleteGroup()}>-</button>
            </OverlayTrigger>&nbsp;&nbsp;

            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Przesuń do góry</Tooltip>}>
              <button className="btn btn-warning" disabled={!this.state.rightLayers || ((this.state.rightLayers) ? this.state.rightLayers.obj.nr <= 1 : false)} onClick={() => this.moveUp()}><i className="glyphicon glyphicon-arrow-up" /></button>
            </OverlayTrigger>&nbsp;&nbsp;

            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Przesuń do dołu</Tooltip>}>
              <button className="btn btn-warning" disabled={!this.state.rightLayers || ((this.state.rightLayers) ? this.state.rightLayers.obj.nr === this.selectR.children.length : false)} onClick={() => this.moveDown()}><i className="glyphicon glyphicon-arrow-down" /></button>
            </OverlayTrigger>&nbsp;&nbsp;
          </div>
        </div>
        <div className="row">
          <div className="layersContainer">
            <div className="layersrow">
              <div className="col-xs-5 no-float">
                <select
                  selected={this.state.leftLayers}
                  size={
                    (
                      (this.state.layers ? this.state.layers.length : 0) + (this.state.extLayers ? this.state.extLayers.length : 0)  > 2
                    ) || (
                      this.state.data.layers.length + this.state.data.groups.length > 2
                    ) ? 10 : 2
                  }
                  className="addLayerSelect"
                  id="sel2"
                  ref={(e) => { this.selectL = e; }}
                >
                  {this.state.layers && this.state.layers.map((v, i) => <option onClick={() => this.optionSelect(v, false)} key={v + i} value={v.name}>{v.name}</option>)}
                  {this.state.extLayers && this.state.extLayers.map((v, i) => <option onClick={() => this.optionSelect(v, true)} key={v + i} value={v.nazwa}>{v.nazwa}</option>)}
                </select>
              </div>
              <div className="col-xs-1 no-float centerButton">
                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Usuń warstwę</Tooltip>}>
                  <button className="btn btn-success" onClick={(e) => this.removeLayer(e)} disabled={!this.state.rightLayers}><i className="glyphicon glyphicon-menu-left" /></button>
                </OverlayTrigger>&nbsp;&nbsp;
              </div>
              <div className="col-xs-1 no-float centerButton">
                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Dodaj warstwę</Tooltip>}>
                  <button className="btn btn-success" onClick={(e) => this.addLayer(e)} disabled={!this.state.leftLayers}><i className="glyphicon glyphicon-menu-right" /></button>
                </OverlayTrigger>&nbsp;&nbsp;
              </div>
              <div className="col-xs-5 no-float">
                <select
                  size={
                    (
                      (this.state.layers ? this.state.layers.length : 0) + (this.state.extLayers ? this.state.extLayers.length : 0)  > 2
                    ) || (
                      this.state.data.layers.length + this.state.data.groups.length > 2
                    ) ? 10 : 2
                  }
                  className="addLayerSelect"
                  ref={(e) => { this.selectR = e; }}
                >
                  {this.state.data.layers.concat(this.state.data.groups).sort((a, b) => a.nr - b.nr).map((v, i) => {
                    if ('grupa' in v) {
                      return <option onClick={(e) => this.onRightOptionSelect(v, false)} className={v.grupa ? 'layerInGroup' : ''} key={v.nr + i} value={v.warstwa}>{v.warstwa}</option>
                    } else {
                      return <option onClick={(e) => this.onRightOptionSelect(v, true)} className="groupOption" key={v.nr + i} value={v.nazwa}>{v.nazwa}</option>
                    }
                  })}
                </select>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
            <label className="col-xs-5">Ogranicz zasięg mapy</label>
        </div>

        <div className="row">
          <div className="col-sm-5" />
          <div className="col-sm-2 text-center">
            <p className="boundingDesc">maxx</p>
          </div>
          <div className="col-sm-5" />
        </div>

        <div className="row">
          <div className="col-sm-3" />
          <div className="col-sm-2 text-center">
            <p className="boundingDesc">miny</p>
          </div>
          <div className="col-sm-2 text-center">
            <input className="form-control" type="text" value="23,30" disabled />
          </div>
          <div className="col-sm-2 text-center">
            <p className="boundingDesc">maxy</p>
          </div>
          <div className="col-sm-3" />
        </div>

        <div className="row">
          <div className="col-sm-3" />
          <div className="col-sm-2 text-center">
            <input className="form-control" type="text" value="50,18" disabled />
          </div>
          <div className="col-sm-2 text-center">
            <p className="boundingDesc">minx</p>
          </div>
          <div className="col-sm-2 text-center">
            <input className="form-control" type="text" value="50,34" disabled />
          </div>
          <div className="col-sm-3" />
        </div>

        <div className="row">
          <div className="col-sm-5" />
          <div className="col-sm-2 text-center">
            <input className="form-control" type="text" value="23,00" disabled />
          </div>
          <div className="col-sm-5" />
        </div>

        <div className="row">
          <div className="col-sm-12">
            <button type="submit" className="btn btn-warning btnMargin">Ustaw</button>
          </div>
        </div>

        <ModalGroupName
          show={this.state.showModalGroupName}
          onHide={this.onHide}
          onOk={this.onOk}
          bodyText={<input type="text" value={this.state.newGroupName} onChange={(e) => this.onChangeNewGroupName(e)} className="form-control" />}
          title="Podaj nazwę nowej grupy"
        />
        <ModalGroupName
          show={this.state.showModalCompositionTypeName}
          onHide={this.onHide}
          onOk={this.onOk}
          bodyText={<input type="text" value={this.state.newCompositionTypeName} onChange={(e) => this.onChangeNewCompositionTypeName(e)} className="form-control" />}
          title="Podaj nazwę nowej kategorii"
        />
        <ModalAlert
          title={this.state.modalTitle}
          bodyText={this.state.modalBody}
          show={this.state.showModal}
          onHide={this.dismissModal}
        />
        {(this.state.data.layers.length > 0) ?
          (<div>
            <button style={fastStyleMargin} onClick={() => this.zapiszKompozycje()} className="btn btn-success">{ this.props.composition ? 'Zapisz' : 'Dodaj' }</button>
            <button style={fastStyleMargin} onClick={() => this.resetComponent()} className="btn btn-warning">Anuluj</button>
          </div>)
          : null}
      </div>
    );
  }
}

const mapState = (state) => ({
  district: state.district.district,
});
const mapDispatch = {
  addComposition,
  setCurrentMapComposition
};

export default withStyles(s)(connect(mapState, mapDispatch)(AddComposition));



// WEBPACK FOOTER //
// src/components/Modals/Settings/Panels/AddComposition/AddComposition.js